import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import './Market2Section.css';

function Market2Section() {
  const { t } = useTranslation();

  return (
    <section id="market2" className="market2-section content-panel">
      <h1 className="market2-headline">{t('market2SectionTitle', 'The Market')}</h1>
      <div className="market2-content">
        <div className="market2-left">
          
          <h2 className="market2-heading">
            <Trans i18nKey="market2MainHeadingCombined" 
                   defaults="<0>The global marine propulsion industry is a </0><1>€20B</1><2> market</2>">
              <span>The global marine propulsion industry is a </span> 
              <span className="highlight-amount">€20B</span>
              <span> market</span>
            </Trans>
          </h2>
          
          <div className="market2-subheading">
            <h3>
              <Trans i18nKey="market2SubHeadingText" 
                     defaults="<0>And only </0><1>2%</1>">
                <span>And only </span>
                <span className="highlight-percent">2%</span>
              </Trans>
            </h3>
            <p className="market2-stat-explanation">
              <Trans i18nKey="market2StatExplanation">
                This corresponds to revenues of <span className="highlight-amount">€16-20M+</span> in 2028.
              </Trans>
            </p>
            <p className="market2-opportunity-statement">
              <Trans i18nKey="market2GrowthStatementText" defaults="<0>12% CAGR</0> Annual Growth of the Total Market">
                <span className="highlight-amount">12% CAGR</span> Annual Growth of the Total Market
              </Trans>
            </p>
          </div>
        </div>
        
        <div className="market2-right">
          <div className="market2-diagram">
            <div className="circle large">
              <div className="circle-content">
                <div className="circle-amount">{t('market2CircleAmountTAM', '$25B+')}</div>
                <div className="circle-label">{t('market2CircleLabelLarge', 'US Death Industry')}</div>
              </div>
            </div>
            
            <div className="circle medium">
              <div className="circle-content">
                <div className="circle-percent">{t('market2CirclePercentMedium', '25%')}</div>
                <img src="/images/logo.svg" alt={t('sylentsLogoAlt', 'Sylents Logo')} className="circle-logo" />
              </div>
            </div>
            
          
            
            <div className="circle-annotation">
              <div className="annotation-line"></div>
              <div className="annotation-content">
                <span className="highlight-amount">{t('market2CircleAmountSAM', '$5B+')}</span> {t('market2AnnotationOpportunity', 'opportunity')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Market2Section; 